module.exports = __webpack_public_path__ + "img/time.ae52fa7e.svg";